import InstantHeader from "./InstantHeader";

export default InstantHeader;
